import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

function normalizeApiUrl(apiUrl = ""): string {
  return apiUrl.trim().replace(/\/+$/, "");
}

export const panther = defineConnector({
  identifier: "panther",
  name: "Panther",
  tagLine: "Cloud-native SIEM and security analytics",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ apiUrl }) =>
    urlToPattern(
      normalizeApiUrl(apiUrl),
      "https://api\\.[^/]*\\.(panther\\.cloud|runpanther\\.net)/.*"
    ),
  auth: (app) => headerAuth([{ name: "X-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [Panther](https://panther.com/) console. Click the gear icon in the upper right, then select **API Tokens**. Generate a new token and copy it.",
        },
      ],
    },
    {
      title: "Enter your Panther details",
      items: [
        {
          kind: "input",
          label: "Panther API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "url",
          label: "API URL",
          required: true,
          target: { kind: "configuration", field: "apiUrl" },
          placeholder: "https://api.your-tenant.runpanther.net/public/graphql",
          helperText:
            "Copy the full API URL shown on the API Tokens page. It should end in /public/graphql.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiUrl }) => ({
      // No fallback: without apiUrl there is no instance to test, and the
      // pattern's fallback (api.<instance>.runpanther.net) would exclude any
      // generic host anyway. Empty URL skips the test as "untested".
      url: normalizeApiUrl(apiUrl),
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "{ __typename }" }),
    }),
  },
});
